/* eslint-disable global-require */
/* boilerplate example of leaflet and webpack: https://github.com/btpschroeder/leaflet-webpack */
import React, { PureComponent } from 'react';

import L, { Map as LeafletMap } from 'leaflet';
import { analyticsTrack } from '../helpers/AnalyticsUtility';
import '../../node_modules/leaflet/dist/leaflet.css';
import icon from '../../node_modules/leaflet/dist/images/marker-icon.png';
import iconShadow from '../../node_modules/leaflet/dist/images/marker-shadow.png';
import { EditionCode } from '../subscription/subscription-types';

/* This code is needed to properly load the images in the Leaflet CSS */
delete L.Icon.Default.prototype._getIconUrl;

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

type Coordinates = {
  latitude: number;
  longitude: number;
};

type MapProps = {
  center: Coordinates;
  markers: Coordinates[];
  subscription: EditionCode;
};

export default class Map extends PureComponent<MapProps> {
  map: LeafletMap;

  componentDidMount() {
    this.map = L.map(this.mapDiv).setView([this.props.center.latitude, this.props.center.longitude], 12);

    analyticsTrack('Form History Map Clicked', {
      tier: this.props.subscription
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(this.map);

    for (const marker of this.props.markers) {
      L.marker([marker.latitude, marker.longitude]).addTo(this.map);
    }
  }

  mapDiv() {
    throw new Error('Method not implemented.');
  }

  render() {
    return (
      <div
        style={{ width: '100%', height: '100%' }}
        ref={(r) => {
          this.mapDiv = r as any;
        }}
      />
    );
  }
}
